import { Pagination } from '@/domain/entities/Pagination'

export class UserData {
  private id: number
  private photo: string
  private photowithouturl: string
  private from: string
  private phone: string
  private email: string
  private isActive: boolean
  private isLogin: boolean
  private lastLogin: string
  private lastAccess: string
  private isRegistered: boolean
  private masterConfig: string
  private salesman: Object
  private grade: Object
  private createdAt: String

  constructor(
    id: number,
    photo: string,
    photowithouturl: string,
    from: string,
    phone: string,
    email: string,
    isActive: boolean,
    isLogin: boolean,
    lastLogin: string,
    lastAccess: string,
    isRegistered: boolean,
    masterConfig: string,
    salesman: Object,
    grade: Object,
    createdAt: string
  ) {
    this.id = id
    this.photo = photo
    this.photowithouturl = photowithouturl
    this.from = from
    this.phone = phone
    this.email = email
    this.isActive = isActive
    this.isLogin = isLogin
    this.lastLogin = lastLogin
    this.lastAccess = lastAccess
    this.isRegistered = isRegistered
    this.masterConfig = masterConfig
    this.salesman = salesman
    this.grade = grade
    this.createdAt = createdAt
  }
}

export class User {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: UserData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: UserData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}

export class Export {
  public success: boolean
  public message: string
  public data?: UserData[]

  constructor(success: boolean, message: string, data?: UserData[]) {
    this.success = success
    this.message = message
    this.data = data
  }
}

export class Import {
  public success: boolean
  public message: string
  public fileName: string
  public fileByte: string

  constructor(
    success: boolean,
    message: string,
    fileName: string,
    fileByte: string
  ) {
    this.success = success
    this.message = message
    this.fileName = fileName
    this.fileByte = fileByte
  }
}
